<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('sportCenter')"></TitlePage>

    <v-layout wrap>

      <v-flex offset-md6 md1 class="pa-4 text-right">
        <v-img :src="item.logo" max-width="50" style="float: right"></v-img>
      </v-flex>
      <v-flex md5 class="pr-4">
        <v-file-input counter show-size truncate-length="15" :label="$t('uploadLogo')" v-model="item.file"></v-file-input>
      </v-flex>

      <v-flex md12 class="d-flex">
        <ServicesAutocomplete v-if="this.item.services != null" @message="setServices" :model="this.item.services"></ServicesAutocomplete>
      </v-flex>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('summary')}}</v-chip>
      </v-flex>

      <v-flex md12 class="pa-4">
        <CKEditor v-if="this.item.summary != null" :content="item.summary" @message="(data) => item.summary = data"></CKEditor>
      </v-flex>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('rules')}}</v-chip>
      </v-flex>

      <v-flex md12 class="pa-4">
        <CKEditor v-if="this.item.rules != null" :content="item.rules" @message="(data) => item.rules = data"></CKEditor>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import CKEditor from "@/components/admin/CKEditor";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ServicesAutocomplete from "@/components/admin/ServicesAutocomplete";
const slugify = require('slugify')

export default {
  name: "InfoCenter",
  components: {ServicesAutocomplete, TitlePage,CKEditor},
  data() {
    return {
      item: {
        summary: null,
        rules: null,
        services: null,
        settings: {},
        logo: "",
        file: null
      },
    };
  },
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    })
  },
  async created(){
    if(!this.getUser.super_admin && this.getUser.center_id != this.$route.params.id){
      this.$router.push('/')
      return
    }
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)

    this.item.summary = fetchItem.result.summary;
    this.item.rules = fetchItem.result.rules;
    this.item.services = fetchItem.result.services;
    this.item.settings = fetchItem.result.settings;
    this.item.logo = fetchItem.result.logo;

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'centers/edit',
      'updateItem':'centers/update',
    }),
    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){
      this.check = true
    },

    async resetError(){
    },

    async setServices(services){
      this.item.services = []
      services.map(x => this.item.services.push(x._id))
    }

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>